module.exports = {"450181100":"横州镇","450181101":"百合镇","450181102":"那阳镇","450181103":"南乡镇","450181104":"新福镇","450181105":"莲塘镇","450181106":"平马镇","450181107":"峦城镇","450181108":"六景镇","450181110":"石塘镇","450181112":"陶圩镇","450181113":"校椅镇","450181114":"云表镇","450181115":"马岭镇","450181118":"马山镇","450181119":"平朗镇","450181204":"镇龙乡","450181400":"南宁六景工业园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450181.json
// module id = 2207
// module chunks = 0